import React from 'react';
const POINTS = [{
  icon: '🏍️',
  title: 'Practical diagnostic resources',
  body: 'Find the relevant system, test or troubleshooting path when you need it.'
}, {
  icon: '🔍',
  title: 'Structured diagnostic processes',
  body: 'Move from symptom to a clearer diagnostic direction.'
}, {
  icon: '⚡',
  title: '6 diagnostic areas',
  body: 'Engine, fuel, electrical, electronics, drivetrain and complete fault finding.'
}, {
  icon: '🔄',
  title: 'Ready to use again and again',
  body: 'Return to the system whenever another motorcycle fault appears.'
}];
export function NotEbook() {
  return <section className="border-b border-line bg-panel py-8 sm:py-10" data-id="element-117" data-mp="3svez65vpida5">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-118" data-mp="1n11h6v1gl54">
        <h2 className="text-center text-[23px] font-bold leading-[1.02] text-white sm:text-[36px]" data-id="element-119" data-mp="1ygvsdr44tnmb">
          This isn't just another motorcycle ebook
        </h2>
        <p className="mt-2 text-center font-display text-[17px] uppercase leading-tight text-brandorange sm:text-[24px]" data-id="element-120" data-mp="23fyzdh3oa3wx">
          It's a ready-to-use diagnostic system.
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-121" data-mp="29yqws8xe5s3i">
          {POINTS.map(point => <div key={point.title} className="flex gap-3 border border-line bg-carbon p-4" data-id="element-122" data-mp="2520dzdu7ciee">
              <span className="text-[22px] leading-none" aria-hidden="true" data-id="element-123" data-mp="200b2jx32i2ps">
                {point.icon}
              </span>
              <div data-id="element-124" data-mp="2sqbc498ik3yz">
                <h3 className="text-[15px] font-bold leading-tight text-white sm:text-[18px]" data-id="element-125" data-mp="2srusdzu66f0r">
                  {point.title}
                </h3>
                <p className="mt-1 text-[13.5px] font-medium leading-snug text-metal sm:text-[15px]" data-id="element-126" data-mp="2ntkw1lwpl8dk">
                  {point.body}
                </p>
              </div>
            </div>)}
        </div>

        <p className="mt-4 text-center font-display text-[15px] uppercase tracking-wide text-white sm:text-[20px]" data-id="element-127" data-mp="18azoiyacu366">
          Less searching. Less guessing. More diagnostic clarity.
        </p>
      </div>
    </section>;
}